;(function ($) {
  "use strict"

  $(document).ready(function () {
    const $tooltip = $(".tooltip")
    const $toolToggle = $(".tooltip-toggle")

    function toggleTooltip() {
      const isVisible = $tooltip.hasClass("is-visible")
      $tooltip.toggleClass("is-visible", !isVisible)
    }

    $toolToggle.on("click", function (event) {
      event.stopPropagation() // Prevent click event from bubbling up
      toggleTooltip()
    })

    // Close tooltip when clicking outside of the tooltip-container
    $(document).on("click", function (event) {
      if (
        !$tooltip.is(event.target) &&
        $tooltip.has(event.target).length === 0
      ) {
        $tooltip.removeClass("is-visible")
      }
    })
  })
})(jQuery)
